import React from "react";
import { getPricingForCard } from "../../../utils/getPrice";

const CardPricing = ({ variant, clubPrice, isAuthenticated }) => {
  return (
    <div className="mt-2">
      <div className="block text-gray-900 text-base font-bold">
        {getPricingForCard(
          variant?.contextualPricing,
          clubPrice,
          isAuthenticated
        )}
      </div>
    </div>
  );
};

export default CardPricing;
